import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo/head";
import { SITE_URL } from "@/lib/seo/routeMeta";
import { getStateBySlug } from "@/data/statesGrants";
import ApprovedLendersByState from "@/pages/ApprovedLendersByState";

export const Route = createFileRoute("/approved-lenders/$state")({
  head: ({ params }) => {
    const info = getStateBySlug(params.state);
    const canonical = `${SITE_URL}/approved-lenders/${params.state}`;
    if (!info) {
      return buildHead({
        title: "Approved Lenders by State | Home Approach",
        description: "Find participating lenders in your state's housing agency program.",
        canonical: `${SITE_URL}/approved-lenders`,
        ogTitle: "Approved Lenders by State",
        ogDescription: "Find participating lenders in your state's housing agency program.",
        ogType: "article",
        noIndex: true,
      });
    }
    const title = `${info.name} Housing Agency Approved Lenders (${info.hfaShort})`;
    const description = `Which lenders participate in ${info.name}'s housing agency program, where to verify the official ${info.hfaShort} participating lender list, and what to ask before you apply.`;
    return buildHead({
      title,
      description,
      canonical,
      ogTitle: title,
      ogDescription: description,
      ogType: "article",
    });
  },
  component: ApprovedLendersByState,
});
